import { render, staticRenderFns } from "./hierarchy-level-item-approvals.vue?vue&type=template&id=6c08b3b4"
import script from "./hierarchy-level-item-approvals.vue?vue&type=script&lang=js"
export * from "./hierarchy-level-item-approvals.vue?vue&type=script&lang=js"
import style0 from "./hierarchy-level-item-approvals.vue?vue&type=style&index=0&id=6c08b3b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports